// extracted by mini-css-extract-plugin
export default {"cls1":"U_aD7pqzum79bFjpreMA","cls2":"NCbAq989vrcKRyqRQYNv U_aD7pqzum79bFjpreMA"};